const primaryMain = '#081E3F';
const primaryMainOpacity = 'rgba(8, 30, 63, 0.9)';
const secondaryMain = '#B6862C';
const secondaryMainOpacity = 'rgba(182, 134, 44, 0.5)';
const secondaryLight = '#F1B609';
const tertiaryMain = '#0B2B5B';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  logoContainerMobile: {
    height: 30,
    marginBottom: 20
  }
};
